import React from 'react'
import PropTypes from 'prop-types'
import {
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  TEXT_ALIGN,
} from '@helpers/constants'
import Container from '@components/Container'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import SectionList from '@components/SectionList'

const FeaturedSectionsGroup = (props) => {
  const { heading, text, sections } = props

  return (
    <Container size={CONTAINER_STYLE.DESKTOP} paddingTop={false}>
      <div className='flex flex-col items-center'>
        {heading && (
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            {heading}
          </Heading>
        )}
        {text && (
          <div className='max-w-[600px]'>
            <Text align={TEXT_ALIGN.CENTER}>{text}</Text>
          </div>
        )}

        <Divider size={DIVIDER_SIZE.BASE} />

        <SectionList items={sections} />
      </div>
    </Container>
  )
}

FeaturedSectionsGroup.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  sections: PropTypes.array,
}

export default FeaturedSectionsGroup
